import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import VehiclesService from "../../services/vehicles.service";
import { VehicleResponse } from "types/trip.types";

interface VehiclesState {
  items: VehicleResponse[];
  loading: boolean;
  error: string | null;
}

const initialState: VehiclesState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchVehicles = createAsyncThunk(
  "vehicles/fetchVehicles",
  async (_, { rejectWithValue }) => {
    try {
      const res = await VehiclesService.getVehicles();
      if (res.ok && res.data) {
        return res.data;
      }
      return rejectWithValue(res.errorMessage || "Failed to fetch vehicles");
    } catch (err) {
      return rejectWithValue("Failed to fetch vehicles");
    }
  }
);

const vehiclesSlice = createSlice({
  name: "vehicles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVehicles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVehicles.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchVehicles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default vehiclesSlice.reducer;
